// Modules
import { getCustomTheme } from '@dasa-health/alma-react'
import { navTokens } from '@dasa-health/alma-tokens'

// Components
import breakPoint from './breakpoints'
import fontSizes from './fontSizes'
import spaces from './spaces'

export const navTheme = getCustomTheme(navTokens)

const CustomTheme = {
    breakPoint,
    fontSizes,
    spaces,
}

export default CustomTheme
